"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BundleContext = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _reactRhumb = require("react-rhumb");

var _reactRedux = require("react-redux");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _MarketingHubBundle = _interopRequireDefault(require("./MarketingHubBundle"));

var _SalesHubBundle = _interopRequireDefault(require("./SalesHubBundle"));

var _ServiceHubBundle = _interopRequireDefault(require("./ServiceHubBundle"));

var _ShoppingCart = _interopRequireDefault(require("./shopping-cart/ShoppingCart"));

var _AddOns = _interopRequireDefault(require("./AddOns"));

var _Services = _interopRequireDefault(require("./Services"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _CurrencyPicker = _interopRequireDefault(require("../common/CurrencyPicker"));

var _FooterMicrocopy = _interopRequireDefault(require("../common/FooterMicrocopy"));

var _getUsageTracker = _interopRequireDefault(require("../../utils/getUsageTracker"));

var _Tracking = require("../../constants/Tracking");

var _CurrencySelectors = require("../../selectors/CurrencySelectors");

var _CountrySelectors = require("../../selectors/CountrySelectors");

var _LoadingStateSelectors = require("pricing-pages-unified-ui/selectors/LoadingStateSelectors");

var _TabLayout = _interopRequireDefault(require("../TabLayout"));

var _AddonBundleRestrictionsMap = _interopRequireDefault(require("pricing-pages-unified-ui/constants/AddonBundleRestrictionsMap"));

var _DocumentUtils = require("pricing-pages-unified-ui/utils/DocumentUtils");

var _PageContainer = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/PageContainer"));

var _SpinnerLoadWrapper = _interopRequireDefault(require("../../components/loading/SpinnerLoadWrapper"));

var _PhoneSupport = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/PhoneSupport"));

var _FailedLoadBanner = _interopRequireDefault(require("pricing-pages-unified-ui/components/loading/FailedLoadBanner"));

var _responsiveBreakpoints = _interopRequireDefault(require("../../utils/responsiveBreakpoints"));

var _CmsHubBundle = _interopRequireDefault(require("pricing-pages-unified-ui/components/bundle-page/CmsHubBundle"));

var _queryParamUtils = require("../../utils/queryParamUtils");

var _stateUtils = require("../../utils/stateUtils");

var _MarketingContactsSelectors = require("../../selectors/MarketingContactsSelectors");

function _templateObject15() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    margin-right: 0;\n  "]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    flex-basis: 60%;\n  "]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  margin-right: 40px;\n  max-width: 100%;\n  min-width: 50%;\n  ", ";\n  ", ";\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    flex-direction: column;\n  "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  ", ";\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    width: 100%;\n  "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    flex-basis: 40%;\n  "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  position: -webkit-sticky;\n  position: sticky;\n  top: 9%;\n  ", ";\n  ", ";\n  margin-bottom: 60px;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    padding: 0 15px;\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 80px;\n  ", ";\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 45px 0 0;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    padding: 0 15px;\n    text-align: left;\n    margin-bottom: 30px;\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  text-align: center;\n  font-size: 16px;\n  margin-bottom: 56px;\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    padding: 0 15px;\n    text-align: left;\n    margin-top: .98em ;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  text-align: center;\n  font-size: 32px;\n  padding-top: 40px;\n  margin-bottom: 10px;\n  font-weight: 600;\n  line-height: 40px;\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var BundleContext = _react.default.createContext(null);

exports.BundleContext = BundleContext;

var PageTitle = _styledComponents.default.div.withConfig({
  displayName: "BundlePage__PageTitle",
  componentId: "sc-1kfcom5-0"
})(_templateObject(), _responsiveBreakpoints.default.tabletPortrait(_templateObject2()));

var SubTitle = _styledComponents.default.div.withConfig({
  displayName: "BundlePage__SubTitle",
  componentId: "sc-1kfcom5-1"
})(_templateObject3(), _responsiveBreakpoints.default.tabletPortrait(_templateObject4()));

var FailedContentContainer = _styledComponents.default.div.withConfig({
  displayName: "BundlePage__FailedContentContainer",
  componentId: "sc-1kfcom5-2"
})(_templateObject5());

var ContentContainer = _styledComponents.default.div.withConfig({
  displayName: "BundlePage__ContentContainer",
  componentId: "sc-1kfcom5-3"
})(_templateObject6(), _responsiveBreakpoints.default.tabletPortrait(_templateObject7()));

var StickyContainer = _styledComponents.default.div.withConfig({
  displayName: "BundlePage__StickyContainer",
  componentId: "sc-1kfcom5-4"
})(_templateObject8(), _responsiveBreakpoints.default.cs(_templateObject9()), _responsiveBreakpoints.default.tabletPortrait(_templateObject10()));

var FlexMain = (0, _styledComponents.default)(_UIFlex.default).withConfig({
  displayName: "BundlePage__FlexMain",
  componentId: "sc-1kfcom5-5"
})(_templateObject11(), _responsiveBreakpoints.default.tabletPortrait(_templateObject12()));

var BundleHubPicker = _styledComponents.default.div.withConfig({
  displayName: "BundlePage__BundleHubPicker",
  componentId: "sc-1kfcom5-6"
})(_templateObject13(), _responsiveBreakpoints.default.cs(_templateObject14()), _responsiveBreakpoints.default.tabletPortrait(_templateObject15()));

var BundlePage = function BundlePage(_ref) {
  var activeCurrencyCode = _ref.activeCurrencyCode,
      country = _ref.country,
      hasPricingAndPurchasingSucceeded = _ref.hasPricingAndPurchasingSucceeded,
      hasPricingAndPurchasingFailed = _ref.hasPricingAndPurchasingFailed;
  var isInMCBeta = (0, _reactRedux.useSelector)(_MarketingContactsSelectors.isInMCBetaSelector);

  var _useBundleState = (0, _stateUtils.useBundleState)(isInMCBeta),
      _useBundleState2 = (0, _slicedToArray2.default)(_useBundleState, 2),
      state = _useBundleState2[0],
      setState = _useBundleState2[1];

  var marketingPlanSelected = state.marketingPlanSelected,
      selectedAddOns = state.selectedAddOns;
  (0, _queryParamUtils.useQueryParamsEffect)(state); // remove any addons that do not fit bundle requirements

  (0, _react.useEffect)(function () {
    Object.keys(_AddonBundleRestrictionsMap.default).forEach(function (addOnId) {
      var isRestricted = _AddonBundleRestrictionsMap.default[addOnId].isRestricted(state);

      if (isRestricted && selectedAddOns.includes(parseInt(addOnId, 10))) {
        var updatedSelectedAddons = selectedAddOns.filter(function (id) {
          return id !== parseInt(addOnId, 10);
        });
        setState({
          selectedAddOns: updatedSelectedAddons
        });
      }
    });
  }, [marketingPlanSelected]);
  (0, _react.useEffect)(function () {
    (0, _getUsageTracker.default)().setProperties({
      activeCurrencyCode: activeCurrencyCode,
      countryTerritory: country
    });
    (0, _getUsageTracker.default)().track('pageView', {
      screen: _Tracking.SCREENS.CREATE_BUNDLE
    });
  }, []);
  return _react.default.createElement(_TabLayout.default, {
    selectedPrimaryTab: "bundle",
    selectedSecondaryTab: "create-a-bundle"
  }, _react.default.createElement(BundleContext.Provider, {
    value: {
      state: state,
      setState: setState
    }
  }, _react.default.createElement(_PageContainer.default, null, hasPricingAndPurchasingFailed && _react.default.createElement(FailedContentContainer, null, _react.default.createElement(_FailedLoadBanner.default, {
    hasFailed: hasPricingAndPurchasingFailed
  })), hasPricingAndPurchasingSucceeded && _react.default.createElement(_reactRhumb.NavMarker, {
    name: "BUNDLE_PAGE"
  }), _react.default.createElement(_CurrencyPicker.default, null), _react.default.createElement(PageTitle, {
    "data-selenium-id": "page-success"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "bundles.pageTitle"
  })), _react.default.createElement(SubTitle, null, _react.default.createElement(_FormattedMessage.default, {
    message: "bundles.subtitle"
  })), _react.default.createElement(ContentContainer, null, _react.default.createElement(FlexMain, null, _react.default.createElement(BundleHubPicker, null, _react.default.createElement(_SpinnerLoadWrapper.default, {
    style: {
      minHeight: '40vh'
    },
    isLoading: !hasPricingAndPurchasingSucceeded
  }, _react.default.createElement(_MarketingHubBundle.default, {
    title: _react.default.createElement(_FormattedMessage.default, {
      message: "bundles.marketing.title"
    }),
    subtitle: _react.default.createElement(_FormattedMessage.default, {
      message: "bundles.marketing.subtitle"
    })
  }), _react.default.createElement(_SalesHubBundle.default, {
    title: _react.default.createElement(_FormattedMessage.default, {
      message: "bundles.sales.title"
    }),
    subtitle: _react.default.createElement(_FormattedMessage.default, {
      message: "bundles.sales.subtitle"
    })
  }), _react.default.createElement(_ServiceHubBundle.default, {
    title: _react.default.createElement(_FormattedMessage.default, {
      message: "bundles.service.title"
    }),
    subtitle: _react.default.createElement(_FormattedMessage.default, {
      message: "bundles.service.subtitle"
    })
  }), _react.default.createElement(_CmsHubBundle.default, {
    title: _react.default.createElement(_FormattedMessage.default, {
      message: "bundles.cms.title"
    }),
    subtitle: _react.default.createElement(_FormattedMessage.default, {
      message: "bundles.cms.subtitle"
    })
  }), _react.default.createElement(_AddOns.default, {
    title: _react.default.createElement(_FormattedMessage.default, {
      message: "bundles.addOns.title"
    }),
    subtitle: _react.default.createElement(_FormattedMessage.default, {
      message: "bundles.addOns.subtitle"
    })
  }), _react.default.createElement(_Services.default, {
    title: _react.default.createElement(_FormattedMessage.default, {
      message: "bundles.services.title"
    }),
    subtitle: _react.default.createElement(_FormattedMessage.default, {
      message: "bundles.services.subtitle"
    })
  }))), _react.default.createElement(StickyContainer, null, _react.default.createElement(_SpinnerLoadWrapper.default, {
    isLoading: !hasPricingAndPurchasingSucceeded
  }, _react.default.createElement(_ShoppingCart.default, null)), _react.default.createElement(_PhoneSupport.default, {
    phoneSourceId: "bundle",
    border: false,
    screen: _Tracking.SCREENS.CREATE_BUNDLE
  }))))), _react.default.createElement(_FooterMicrocopy.default, null)));
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    activeCurrencyCode: (0, _CurrencySelectors.activeCurrencySelector)(state),
    country: (0, _CountrySelectors.countrySelector)(state),
    hasPricingAndPurchasingFailed: (0, _LoadingStateSelectors.hasPricingAndPurchasingFailedSelector)(state),
    hasPricingAndPurchasingSucceeded: (0, _LoadingStateSelectors.hasPricingAndPurchasingSucceededSelector)(state)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)((0, _DocumentUtils.withDocumentTitle)(BundlePage, 'bundle'));

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./js/components/bundle-page/BundlePage.js
// module id = 84
// module chunks = 5 6